module.exports = __webpack_public_path__ + "img/SDG-04-EN.f8278481.png";